import { useState } from "react";

interface Props {
  src?: string | null;     // a URL to try (returns 404 → fallback)
  name: string | null;
  email: string;
  size?: number;
  className?: string;
  rounded?: "full" | "md";
}

// Deterministic background color from email. Mirrors the calendar avatar.
function bgColor(seed: string): string {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) | 0;
  const hue = Math.abs(h) % 360;
  return `hsl(${hue} 45% 38%)`;
}

export default function Avatar({ src, name, email, size = 32, className = "", rounded = "full" }: Props) {
  const [failed, setFailed] = useState(false);
  const initial = (name?.trim() || email).slice(0, 1).toUpperCase();
  const bg = bgColor(email.toLowerCase());
  const cls = `${rounded === "full" ? "rounded-full" : "rounded-md"} grid place-items-center text-white font-semibold shrink-0 ${className}`;
  const style = { width: size, height: size, background: bg, fontSize: Math.max(10, size * 0.42) };
  if (src && !failed) {
    return (
      <img
        src={src}
        alt=""
        width={size}
        height={size}
        className={`${rounded === "full" ? "rounded-full" : "rounded-md"} shrink-0 object-cover ${className}`}
        style={{ width: size, height: size }}
        onError={() => setFailed(true)}
      />
    );
  }
  return <div className={cls} style={style} aria-hidden="true">{initial}</div>;
}
